import type { IconNode } from '../types';

/**
 * @name candlestick-big-lit
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMlM5IDUuMyA5IDdzMS4zIDMgMyAzIDMtMS4zIDMtMy0zLTUtMy01IiAvPgogIDxwYXRoIGQ9Ik0xNiAyMkg4di03YzAtLjYuNC0xIDEtMWg2Yy42IDAgMSAuNCAxIDFaIiAvPgogIDxwYXRoIGQ9Ik0xMiAxNHYzIiAvPgogIDxwYXRoIGQ9Ik0xNyAxN3MtLjctMS40LTEuMS0yLjQiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/candlestick-big-lit
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const candlestickBigLit: IconNode = [
  ['path', { d: 'M12 2S9 5.3 9 7s1.3 3 3 3 3-1.3 3-3-3-5-3-5', key: '16iet1' }],
  ['path', { d: 'M16 22H8v-7c0-.6.4-1 1-1h6c.6 0 1 .4 1 1Z', key: '144h05' }],
  ['path', { d: 'M12 14v3', key: '5nyt84' }],
  ['path', { d: 'M17 17s-.7-1.4-1.1-2.4', key: 'orsx8w' }],
];

export default candlestickBigLit;
